import React from 'react';

const Fg1 = () => {
	return <div style={{ flexGrow: 1 }}></div>;
};

export default Fg1;
